<script>
import SidebarMenuCollapsed from 'components/ui/menu/sidebar-menu-collapsed';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'nuttrema-navigation-menu',
  mixins: [SidebarMenuCollapsed],
  components: {
    NuttremaIconicaSidebarLink,
  },
  props: {
    id: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      startingUrl: '/professional/persons/participants/',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/persons/sidebar-menu-participant-collapsed.vue